import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { SubscriptionService } from '@core/_services/subscription/subscription.service';

@Component({
  selector: 'app-subscription-modal',
  templateUrl: './subscription-paywall-modal.component.html',
  styleUrls: ['./subscription-paywall-modal.component.scss'],
})
export class SubscriptionPaywallModalComponent {
  constructor(
    private dialog: MatDialog,
    private subscriptionService: SubscriptionService
  ) {
  }

  dismiss(): void {
    this.dialog.closeAll();
  }

  onSubscribe(): void {
    this.subscriptionService.openSubscriptionDialog(true);
  }
}
